import { render, staticRenderFns } from "./purchaseApplyDetailList.vue?vue&type=template&id=478c9d18&scoped=true"
import script from "./purchaseApplyDetailList.vue?vue&type=script&lang=js"
export * from "./purchaseApplyDetailList.vue?vue&type=script&lang=js"
import style0 from "./purchaseApplyDetailList.vue?vue&type=style&index=0&id=478c9d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c9d18",
  null
  
)

export default component.exports